// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbar_root__MXZCr"};